// 签署

export default {
  path: '/trial',
  component: () => import('@/layout/Empty.vue'),
  children: [
    {
      path: '',
      name: 'Trial',
      component: () => import('@/views/user/trial/Trial.vue'),
      meta: {
        title: '体验签',
        layout: {
          subPage: true,
          pageWrap: false
        }
      }
    },
    {
      path: 'success',
      name: 'TrialSuccess',
      component: () => import('@/views/user/trial/TrialSuccess.vue')
    }
  ]
}
